<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_reports'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-moneytransfer size="sm" variant="primary"
                ><i class="mdi mdi-plus"></i> New Money Transfer</b-button
              >
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy
                  ><div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div></template
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(account_from)="data">
                  {{ data.item.account_from.name }}
                </template>
                <template #cell(account_to)="data">
                  {{ data.item.account_to.name }}
                </template>
                <template #cell(added_by)="data">
                  {{ data.item.added_by.username }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button
                      @click="remove(data.item.id, data.item.account_to.name)"
                      type="button"
                      class="btn-sm btn"
                      variant="danger"
                      v-b-modal.delete
                    >
                      <i class="mdi mdi-trash-can"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-moneytransfer"
        centered
        title="New Money Transfer"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addMoneyTransfer">
          <div class="form-group mb-2">
            <label>Account From</label>
            <multiselect
              v-model="account_from"
              label="name"
              :options="paymentoptions"
            ></multiselect>
            <label>Account To</label>
            <multiselect
              v-model="account_to"
              label="name"
              :options="paymentoptions"
            ></multiselect>
            <label>Amount</label>
            <input v-model="amount" type="number" class="form-control" />
            <label>Description</label>
            <textarea v-model="description" class="form-control" />
            <label>Transfer Date</label>
            <input v-model="transfer_date" type="date" class="form-control" />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-moneytransfer')"
              >Cancel</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-moneytransfer"
        centered
        title="Delete Money Transfer"
        title-class="font-12"
        hide-footer
      >
        <form @submit.prevent="removeMoneyTransfer">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Money Transfer :
          <b>{{ name }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-moneytransfer')"
              >Cancel</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  moneytransferMethods,
  moneytransferComputed,
  paymentoptionMethods,
  paymentoptionComputed,
} from "@/state/helpers";

export default {
  page: {
    title: "Money Transfers",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Money Transfers",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Money Transfers", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "account_from", label: "Account From", visible: true },
        { key: "account_to", label: "Account to", visible: true },
        { key: "amount", label: "Amount", visible: true },
        { key: "description", label: "Description", visible: true },
        { key: "transfer_date", label: "Transfer Date", visible: true },
        { key: "added_by", label: "Added by", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      name: "",
      id: "",
      account_from: "",
      account_to: "",
      amount: "",
      description: "",
      transfer_date: new Date().toLocaleDateString("fr-CA"),
    };
  },
  computed: {
    ...moneytransferComputed,
    ...paymentoptionComputed,
    List() {
      return this.moneytransfers.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.moneytransfers.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.moneytransfers.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchMoneyTransfers();
    this.fetchPaymentoptions();
    this.TotalRows = this.moneytransfers.length;
    this.isBusy = false;
  },
  methods: {
    ...moneytransferMethods,
    ...paymentoptionMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show("delete-moneytransfer");
    },
    async addMoneyTransfer() {
      let formData = new FormData();
      formData.append("account_from", this.account_from.id);
      formData.append("account_to", this.account_to.id);
      formData.append("amount", this.amount);
      formData.append("description", this.description);
      formData.append("transfer_date", this.transfer_date);
      let url = "/addmoneytransfer";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchMoneyTransfers();
          this.$bvModal.hide("new-moneytransfer");
          this.account_from = "";
          this.account_to = "";
          this.amount = "";
          this.description = "";
        }
      });
    },
    async removeMoneyTransfer() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removemoneytransfer";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchMoneyTransfers();
          this.$bvModal.hide("delete-moneytransfer");
        }
      });
    },
  },
};
</script>
